var $524caea23ab94ad7$exports = {};
$524caea23ab94ad7$exports = {
    "(optional)": `(valgfritt)`,
    "(required)": `(obligatorisk)`
};


export {$524caea23ab94ad7$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
